import React from 'react';

const PATHS = {
  android:
    'M6 9.5h12V18a1.5 1.5 0 0 1-1.5 1.5h-.9v2.1a1.35 1.35 0 0 1-2.7 0v-2.1h-1.8v2.1a1.35 1.35 0 0 1-2.7 0v-2.1h-.9A1.5 1.5 0 0 1 6 18V9.5Zm-2.65 0A1.35 1.35 0 0 1 4.7 10.85v4.3a1.35 1.35 0 0 1-2.7 0v-4.3A1.35 1.35 0 0 1 3.35 9.5Zm17.3 0A1.35 1.35 0 0 1 22 10.85v4.3a1.35 1.35 0 0 1-2.7 0v-4.3a1.35 1.35 0 0 1 1.35-1.35ZM15.7 4.3l1-1.55a.35.35 0 0 0-.6-.35l-1.05 1.6a7.2 7.2 0 0 0-6.1 0L7.9 2.4a.35.35 0 0 0-.6.35l1 1.55A5.7 5.7 0 0 0 6 8.6h12a5.7 5.7 0 0 0-2.3-4.3ZM9.6 6.9a.68.68 0 1 1 0-1.35.68.68 0 0 1 0 1.35Zm4.8 0a.68.68 0 1 1 0-1.35.68.68 0 0 1 0 1.35Z',
  ios: 'M16.9 12.6c0-2.35 1.92-3.48 2-3.53-1.09-1.6-2.79-1.82-3.39-1.84-1.44-.15-2.81.85-3.54.85-.73 0-1.85-.83-3.04-.81-1.56.02-3 .91-3.81 2.3-1.62 2.82-.41 6.99 1.17 9.28.77 1.12 1.69 2.38 2.9 2.33 1.16-.05 1.6-.75 3-.75s1.8.75 3.03.73c1.25-.02 2.04-1.14 2.8-2.26.88-1.29 1.25-2.55 1.27-2.61-.03-.01-2.43-.94-2.45-3.69ZM14.6 5.5c.64-.78 1.07-1.86.95-2.94-.92.04-2.03.61-2.69 1.39-.59.69-1.11 1.79-.97 2.85 1.03.08 2.08-.52 2.71-1.3Z',
};

export default function PlatformIcon({ platform, size = 16, className }) {
  const path = PATHS[platform];
  if (!path) return null;

  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      className={className}
    >
      <path d={path} />
    </svg>
  );
}
